export enum AlertType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
}

export type AlertProps = {
  id: number;
  message: string;
  canDismiss?: boolean;
  title?: string;
  type?: AlertType;
};
